import { render } from "./partsDatatable.vue?vue&type=template&id=a7619f70"
import script from "./partsDatatable.vue?vue&type=script&lang=js"
export * from "./partsDatatable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__